import * as React from "react";
import { cn } from "../utils/cn";

const GRADIENT_PAIRS = [
    [
        "from-pink-400",
        "to-rose-600",
    ],
    [
        "from-violet-500",
        "to-purple-700",
    ],
    [
        "from-sky-400",
        "to-blue-600",
    ],
    [
        "from-emerald-400",
        "to-teal-600",
    ],
    [
        "from-orange-400",
        "to-amber-600",
    ],
    [
        "from-cyan-400",
        "to-sky-600",
    ],
    [
        "from-fuchsia-400",
        "to-pink-600",
    ],
    [
        "from-lime-400",
        "to-green-600",
    ],
    [
        "from-red-400",
        "to-rose-700",
    ],
    [
        "from-indigo-400",
        "to-violet-600",
    ],
    [
        "from-teal-400",
        "to-emerald-600",
    ],
    [
        "from-amber-400",
        "to-orange-600",
    ],
    [
        "from-rose-400",
        "to-pink-700",
    ],
    [
        "from-blue-400",
        "to-indigo-600",
    ],
    [
        "from-green-400",
        "to-emerald-700",
    ],
    [
        "from-purple-400",
        "to-fuchsia-600",
    ],
    [
        "from-yellow-400",
        "to-amber-700",
    ],
    [
        "from-slate-400",
        "to-gray-600",
    ],
    [
        "from-cyan-500",
        "to-blue-700",
    ],
    [
        "from-pink-300",
        "to-violet-600",
    ],
];

function getGradientForId(id: string): [string, string] {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
        hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
    }
    const [
        from = "from-slate-400",
        to = "to-slate-600",
    ] = GRADIENT_PAIRS[hash % GRADIENT_PAIRS.length] ?? [];
    return [
        from,
        to,
    ];
}

export type OrgAvatarSize = "xs" | "sm" | "md" | "lg" | "xl";

const sizeMap: Record<OrgAvatarSize, string> = {
    xs: "h-6 w-6 text-[10px]",
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-12 w-12 text-base",
    xl: "h-16 w-16 text-lg",
};

export interface OrgAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
    id: string;
    fallback: string;
    size?: OrgAvatarSize;
}

const OrgAvatar = React.forwardRef<HTMLDivElement, OrgAvatarProps>(
    ({ className, id, fallback, size = "md", ...props }, ref) => {
        const [
            from,
            to,
        ] = getGradientForId(id);
        return (
            <div
                ref={ref}
                className={cn(
                    "font-display flex shrink-0 items-center justify-center rounded-lg bg-gradient-to-br font-bold text-white",
                    from,
                    to,
                    sizeMap[size],
                    className,
                )}
                {...props}
            >
                {fallback}
            </div>
        );
    },
);
OrgAvatar.displayName = "OrgAvatar";

export { OrgAvatar, getGradientForId };
